import React from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import {Moon, Sun} from 'lucide-react';

interface ThemeToggleProps {
    theme: string;
    setTheme: (theme: string) => void;
}

export function ThemeToggle({theme, setTheme}: ThemeToggleProps) {
    const isDark = theme === 'dark';

    return (
        <button
            aria-label={isDark ? 'Przełącz na tryb jasny' : 'Przełącz na tryb ciemny'}
            onClick={() => setTheme(isDark ? 'light' : 'dark')}
            className="relative flex items-center justify-center w-11 h-11 rounded-xl border border-border/50 bg-muted/30 backdrop-blur-md hover:bg-muted/50 hover:border-primary/30 active:scale-95 transition-all duration-300 cursor-pointer group"
        >
            <AnimatePresence mode="wait" initial={false}>
                {isDark ? (
                    <motion.div
                        key="moon"
                        initial={{rotate: -90, scale: 0, opacity: 0}}
                        animate={{rotate: 0, scale: 1, opacity: 1}}
                        exit={{rotate: 90, scale: 0, opacity: 0}}
                        transition={{duration: 0.25, ease: 'easeInOut'}}
                    >
                        <Moon size={18} className="text-primary-dark"/>
                    </motion.div>
                ) : (
                    <motion.div
                        key="sun"
                        initial={{rotate: 90, scale: 0, opacity: 0}}
                        animate={{rotate: 0, scale: 1, opacity: 1}}
                        exit={{rotate: -90, scale: 0, opacity: 0}}
                        transition={{duration: 0.25, ease: 'easeInOut'}}
                    >
                        <Sun size={18} className="text-primary"/>
                    </motion.div>
                )}
            </AnimatePresence>
            <div
                className="absolute inset-0 rounded-xl bg-primary/10 scale-150 opacity-0 group-hover:opacity-100 blur-lg transition-opacity duration-300"/>
        </button>
    );
}
